export const SIGN_UP = "signUpApi";
export const FORGOT_PASSWORD = "forgotPasswordApi";
export const PASSWORD_RECOVERY = "passwordRecoveryApi";
export const LOGIN = "loginApi";
export const LOGOUT = "logoutApi";

export const GET_EMAIL_FOR_TOKEN_SIGNUP = "getEmailForTokenSignUpApi";
export const GET_EMAIL_FOR_TOKEN_RECOVERY = "getEmailForTokenPasswordApi";
